import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncAbTests = Load(
  () => import(/* webpackChunkName: "ab-tests" */ './components/AbTests'),
  {},
  true,
);

const AbTestsRoute = (
  <NavigationableLayout
    path={`${basePath}/ab-tests`}
    component={AsyncAbTests}
    nonFixedNavbar
  />
);

export default AbTestsRoute;
